import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const padTimeUnit = (unit) => String(unit).padStart(2, "0");

export const localDateString = (thedate) => {
  const year = thedate.getFullYear();
  const month = String(thedate.getMonth() + 1).padStart(2, "0");
  const day = String(thedate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatToDisplayWithSeparators = (numericString) => {
  if (
    numericString === null ||
    numericString === undefined ||
    numericString === ""
  )
    return "";

  return String(numericString).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const parseInputToNumericString = (inputValue) => {
  if (inputValue === null || inputValue === undefined || inputValue === "")
    return "";
  let numericString = String(inputValue).replace(/[^\d]/g, "");

  if (numericString === "") return "";

  if (numericString.length > 1 && numericString.startsWith("0")) {
    const firstNonZeroIndex = numericString.search(/[^0]/);
    if (firstNonZeroIndex === -1) {
      numericString = "0";
    } else {
      numericString = numericString.substring(firstNonZeroIndex);
    }
  }
  return numericString;
};

export const getWeekStartAndEndDates = (date) => {
  const current = new Date(date);
  const dayOfWeek = current.getDay(); // Get the day of the week (0 - Sunday, 6 - Saturday)

  // Calculate Monday (start of the week)
  const monday = new Date(current);
  monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  // Calculate Friday (end of the week)
  const friday = new Date(monday);
  friday.setDate(monday.getDate() + 4);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  return { startDate: monday, endDate: sunday };
};
